import { callAPIContent } from '@utils/fetcher/content';
import { IParamLogin } from './login.types';

export const postLoginFromAPI = (params: IParamLogin) => {
  const options = {
    method: 'POST',
    servicePath: 'auth',
    uri: 'login',
    params,
  };
  return callAPIContent(options);
};

export const getMeProfileFromAPI = () => {
  const options = {
    method: 'GET',
    servicePath: 'users',
    uri: 'me',
  };
  return callAPIContent(options);
};
